// openEHR LANG model — BMM package org.openehr.lang.bmm.core
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import type { BMM_TYPE } from "./core/entity.ts";
import { BMM_SIGNATURE } from "./core/entity.ts";
import { BMM_MODEL_ELEMENT } from "./core/element.ts";
import * as openehr_base from "../../base/mod.ts";

export { BMM_MODEL_ELEMENT } from "./core/element.ts";

/**
 * A formal element having a name, type and a type-based signature.
 */
export abstract class BMM_FORMAL_ELEMENT extends BMM_MODEL_ELEMENT {
  /**
   * Declared or inferred static type of the entity.
   */
  type?: BMM_TYPE;
  /**
   * Internal storage for is_nullable
   * @protected
   */
  protected _is_nullable?: openehr_base.Boolean;

  /**
   * True if this element can be null (Void) at execution time. May be interpreted as optionality in subtypes..
   */
  get is_nullable(): boolean | undefined {
    return this._is_nullable?.value;
  }

  /**
   * Gets the openehr_base.Boolean wrapper object for is_nullable.
   * Use this to access openehr_base.Boolean methods.
   */
  get $is_nullable(): openehr_base.Boolean | undefined {
    return this._is_nullable;
  }

  /**
   * Sets is_nullable from either a primitive value or openehr_base.Boolean wrapper.
   */
  set is_nullable(val: boolean | openehr_base.Boolean | undefined) {
    if (val === undefined || val === null) {
      this._is_nullable = undefined;
    } else if (typeof val === "boolean") {
      this._is_nullable = openehr_base.Boolean.from(val);
    } else {
      this._is_nullable = val;
    }
  }

  /**
   * Formal signature of this element, in the form:
   *
   * \`name [arg1_name: T_arg1, ...][:T_value]\`
   *
   * Specific implementations in descendants.
   * @returns Result value
   */
  signature(): BMM_SIGNATURE {
    const sig = new BMM_SIGNATURE();
    if (this.type) sig.result_type = this.type;
    return sig;
  }

  /**
   * True if \`_type_\` is notionally Boolean (i.e. a \`BMM_SIMPLE_TYPE\` with \`_type_name()_\` = \`'Boolean'\`).
   * @returns Result value
   */
  is_boolean(): openehr_base.Boolean {
    if (!this.type) {
      return openehr_base.Boolean.from(false);
    }
    const typeName = this.type.type_name ? this.type.type_name() : undefined;
    const typeNameStr = typeName?.value || String(typeName || "");
    return openehr_base.Boolean.from(
      typeNameStr.toLowerCase() === "boolean",
    );
  }
}
